import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { swal, typeChecker } from "../../../utils/methods";
import { _post } from "../../../utils/network";

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';

const TransactionCategoriesCreate = ({ componentType='create' }) => {
	const { t } = useTranslation();
	const { id } = useParams();
    const navigate = useNavigate();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('transaction_categories'), link: '/transaction-categories-list' },
		{ title: t(componentType) }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};

	const [createButtonIsLoading, setCreateButtonIsLoading] = useState(false);
	const createTransactionCategory = async (event) => {
		event.preventDefault();
		if(createButtonIsLoading)
			return 0;
		let title = event.target.transactionCategoryTitle.value.trim();
		if(!typeChecker(title, 'title'))
			return toast.warn(t('title') + ' ' + t('must_have_at_least_3_characters'));
		let is_active = event.target.transactionCategoryIsActive.checked ? 1 : 0;
		let body = {
			transactioncategory_id: id,
			transactioncategory_name: title,
			is_active,
			transactioncategory_information: {}
		};
		confirmSwal(async () => {
			setCreateButtonIsLoading(true);
			let response = await _post('/transactioncategories/admin/' + componentType, body);
			setCreateButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					if(componentType === 'create')
						event.target.reset();
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	const [deleteButtonIsLoading, setDeleteButtonIsLoading] = useState(false);
	const deleteTransactioncategory = async () => {
		if(deleteButtonIsLoading)
			return 0;
		let body = {
			transactioncategory_id: id
		};
		confirmSwal(async () => {
			setDeleteButtonIsLoading(true);
			let response = await _post('/transactioncategories/admin/delete', body);
			setDeleteButtonIsLoading(false);
			switch(response.code){
				case 200:
					navigate("/transaction-categories-list");
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	const [transactioncategory, setTransactioncategory] = useState({});
	const getTransactionCategory = async () => {
		let body = {
			transactioncategory_id: id
		};
		let response = await _post('/transactioncategories/admin/getOne', body);
		switch(response.code){
			case 200:
				setTransactioncategory(response.data.transactioncategory);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	const transactionCategoryTypesList = [
		{ key: t('portal'), value: 1 },
		{ key: t('marketers_club'), value: 2 }
	];

	useEffect(() => {
		if(componentType === 'edit')
			getTransactionCategory();
	}, []);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t(componentType)} {t('transaction_category')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={createTransactionCategory}>
						<div className="row gx-2">
							<FormField fieldKey="transactionCategoryTitle" title={t('title')} value={transactioncategory?.transactioncategory_name} required rtl />
							<FormField type="toggle" fieldKey="transactionCategoryIsActive" title={t('active')} value={transactioncategory?.is_active} required />
						</div>
						<div>
							{componentType === 'create' ?
								<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={createButtonIsLoading}>
									<i className="fa fa-save"></i> {t('create')}
								</LoadingButton>
							:
								<>
									<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="edit" isLoading={createButtonIsLoading}>
										<i className="fa fa-save"></i> {t('update')}
									</LoadingButton>
								</>
							}
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default TransactionCategoriesCreate;
